import React from "react";
import { Link } from "react-router-dom";
import { Layout, Space, Button } from "antd";
import {
  LinkedinOutlined,
  InstagramOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import logo from "../../assets/images/logo1.svg";

const { Header } = Layout;

const HEADER_HEIGHT = 72;

const styles = {
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: HEADER_HEIGHT,
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgb(231, 237, 233)",
    backgroundRepeat: "repeat",
    backgroundPosition: "top",
    backgroundSize: "contain",
    paddingInline: 16,
    boxShadow:"rgba(0, 0, 0, 0.1) 0px 2px 8px"
  },
  inner: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  logo: {
    height: 60,
  },
  grow: { flex: 1 },
  menu: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    flex: 1, // keeps links centered between logo and socials
  },
  link: {
    margin: "0 10px",
    color: "rgb(41, 58, 44)",
    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
    fontWeight: "bold",
    textDecoration: "none",
    fontSize: 16,
    whiteSpace: "nowrap",
  },
  socials: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  offset: {
    height: HEADER_HEIGHT,
  },
};

const Navbar = () => {
  return (
    <>
      <Header style={styles.header}>
        <div style={styles.inner}>
          {/* Left: Logo */}
          <Link to="/">
            <img src={logo} alt="logo" style={styles.logo} />
          </Link>

          {/* Center: Always-visible menu (same on all screen sizes) */}
          <nav style={styles.menu}>
            <Link to="/login" style={styles.link}>
              Login
            </Link>
            <Link to="/register" style={styles.link}>
              Register
            </Link>
          </nav>

          {/* Right: Social icons */}
          <div style={styles.socials}>
            <Space size={4}>
              <Button
                type="text"
                href="https://www.linkedin.com/company/backupjo/"
                target="_blank"
                aria-label="LinkedIn"
                icon={<LinkedinOutlined style={{ fontSize: 22, color: "#0077b5" }} />}
              />
              <Button
                type="text"
                href="https://www.instagram.com/back.upjo?igsh=eDRiOGQ5emxxOW9z"
                target="_blank"
                aria-label="Instagram"
                icon={<InstagramOutlined style={{ fontSize: 22, color: "#E1306C" }} />}
              />
              <Button
                type="text"
                href="https://wa.me/+962792424141"
                target="_blank"
                aria-label="WhatsApp"
                icon={<WhatsAppOutlined style={{ fontSize: 22, color: "#30e16bff" }} />}
              />
            </Space>
          </div>
        </div>
      </Header>

      {/* Spacer so page content isn't hidden under the fixed header */}
      <div style={styles.offset} />
    </>
  );
};

export default Navbar;
